"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getClientId = void 0;
function getClientId(cookieManager, _a) {
    var validAfter = (_a === void 0 ? {} : _a).validAfter;
    var id = cookieManager.get('utClientId');
    if (!id || (validAfter && getTimestamp(id) < validAfter)) {
        id =
            'UT.' +
                Date.now() +
                Math.random()
                    .toString()
                    .substr(1);
        cookieManager.set('utClientId', id, {
            expires: new Date(Date.now() + 2 * 365 * 24 * 60 * 60 * 1000) // now + 2y
        });
    }
    return id;
}
exports.getClientId = getClientId;
function getTimestamp(id) {
    var _a = id.split('.'), result = _a[1];
    return +result;
}
